define('Digi.Marketing.Marketing.Router'
, [
    'Backbone'
  , 'Digi.Marketing.Marketing.View'
  ]
, function
  (
    Backbone
  , DigiMarketingListView
  )
{
  'use strict';

  return Backbone.Router.extend({
    routes:
    {
      'marketingHub': 'partnerPortalView'
    }

  , initialize: function (container)
    {
      this.application = container;
      this.UserProfile = container.getComponent('UserProfile');
    }

  , partnerPortalView: function ()
    {
      var self = this;
      this.UserProfile.getUserProfile().then(function (profileData)
      {
        var view = new DigiMarketingListView
        ({
          application: self.application
        , UserProfile: profileData
        })

        view.showContent();
      });
    }

  })

});
